import './CardsHeaderMinisterio.css';

export default function CardsHeaderMinisterio(props) {
    return (
        <div id="dv_Ministerio_Card">
            <h3 id="tx_Ministerio_Card">{props.txt_Ministerio}</h3>
        </div>
    );
  }